import styled from '@emotion/styled';
import { CloseIcon } from 'src/domains/layouts/shared/assets/icons/CloseIcon';
import { withConfig } from 'src/withConfig';

export const ClosureAnnouncementReveal = styled('div', { label: 'ClosureAnnouncementReveal' })<{ visible: boolean }>`
    display: grid;
    grid-template-rows: ${({ visible }): string => (visible === true ? '1fr' : '0fr')};
    transition: grid-template-rows 0.45s ease-out;
`;

export const ClosureAnnouncementRevealInner = styled('div', { label: 'ClosureAnnouncementRevealInner' })`
    min-height: 0;
    overflow: hidden;
`;

export const ClosureAnnouncementBarRoot = withConfig(theme => styled('div', { label: 'ClosureAnnouncementBarRoot' })<{ visible: boolean }>`
    background: ${theme.star.midnightMigration.bgColorOctonary};
    box-sizing: border-box;
    color: ${theme.star.midnightMigration.txtColor};
    flex-shrink: 0;
    padding: 16px 20px;
    position: relative;
    text-align: center;
    transform: ${({ visible }): string => (visible === true ? 'translateY(0)' : 'translateY(-100%)')};
    transition: transform 0.45s ease-out;
    width: 100%;
    z-index: ${theme.star.zIndexBanners.marketingNotification};

    @media ${theme.star.mediaQuery.tablet} {
        padding: 18px 24px;
    }
`);

export const ClosureAnnouncementBarInner = styled('div', { label: 'ClosureAnnouncementBarInner' })`
    box-sizing: border-box;
    margin: 0 auto;
    max-width: 1200px;
`;

export const ClosureAnnouncementBarText = withConfig(theme => styled('p', { label: 'ClosureAnnouncementBarText' })`
    font-size: ${theme.star.fontSize.xRegular};
    line-height: 1.42;
    margin: 0;
`);

export const ClosureAnnouncementReadMore = withConfig(theme => styled('button', { label: 'ClosureAnnouncementReadMore' })`
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    display: inline;
    font: inherit;
    font-weight: ${theme.star.fontWeight.bold};
    margin: 0;
    padding: 0;
    text-decoration: underline;
    vertical-align: baseline;
`);

export const ClosureAnnouncementModalBackdrop = withConfig(theme => styled('div', { label: 'ClosureAnnouncementModalBackdrop' })`
    align-items: center;
    background: ${theme.star.midnightMigration.bgColorSeptenary};
    box-sizing: border-box;
    display: flex;
    inset: 0;
    justify-content: center;
    overflow-y: auto;
    padding: 24px 16px;
    position: fixed;
    z-index: ${theme.star.zIndexGlobal.highLevel};
`);

export const ClosureAnnouncementModalPanel = withConfig(theme => styled('div', { label: 'ClosureAnnouncementModalPanel' })`
    background: ${theme.star.midnightMigration.bgColorQuinary};
    border-radius: 16px;
    box-sizing: border-box;
    color: ${theme.star.midnightMigration.txtColor};
    margin: auto;
    max-height: min(720px, calc(100dvh - 48px));
    max-width: 560px;
    overflow-y: auto;
    padding: 36px 32px 40px;
    position: relative;
    width: 100%;

    @media ${theme.star.mediaQuery.tablet} {
        padding: 40px 40px 44px;
    }
`);

export const ClosureAnnouncementModalClose = withConfig(theme => styled('button', { label: 'ClosureAnnouncementModalClose' })`
    align-items: center;
    background: ${theme.star.midnightMigration.bgColorOctonary};
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    height: 36px;
    justify-content: center;
    margin: 0;
    padding: 0;
    position: absolute;
    right: 16px;
    top: 16px;
    width: 36px;

    &:hover {
        opacity: 0.9;
    }
`);

export const ClosureAnnouncementCloseIcon = withConfig(theme => styled(CloseIcon, { label: 'ClosureAnnouncementCloseIcon' })`
    display: block;
    height: 14px;
    width: 14px;
    fill: ${theme.star.midnightMigration.txtColor};
`);

export const ClosureAnnouncementModalTitle = withConfig(theme => styled('h2', { label: 'ClosureAnnouncementModalTitle' })`
    color: ${theme.star.midnightMigration.txtColor};
    font-size: 22px;
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.3;
    margin: 0 40px 20px 0;
    padding: 0;

    @media (min-width: 768px) {
        font-size: 26px;
    }
`);

export const ClosureAnnouncementModalDescription = withConfig(theme => styled('p', { label: 'ClosureAnnouncementModalDescription' })`
    color: ${theme.star.midnightMigration.txtColor};
    font-size: ${theme.star.fontSize.small};
    line-height: 1.45;

    &:first-of-type {
        margin-top: 0;
    }

    @media ${theme.star.mediaQuery.tablet} {
        font-size: ${theme.star.fontSize.xRegular};
    }
`);

export const ClosureAnnouncementModalSectionHeading = withConfig(theme => styled('h3', { label: 'ClosureAnnouncementModalSectionHeading' })`
    color: ${theme.star.midnightMigration.txtColor};
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.35;
    margin: 24px 0 0;
`);

export const ClosureAnnouncementModalMailLink = withConfig(theme => styled('a', { label: 'ClosureAnnouncementModalMailLink' })`
    color: ${theme.star.midnightMigration.txtColor};
    cursor: pointer;
    font-weight: ${theme.star.fontWeight.bold};
    text-decoration: underline;
`);
